import { create } from "zustand";

interface SubscriptionIdState {
  subscriptionId: string | null;
  setSubscriptionId: (id: string | null) => void;
}

const useSubscriptionIdStore = create<SubscriptionIdState>((set) => ({
  subscriptionId: null,
  setSubscriptionId: (id) => set({ subscriptionId: id }),
}));

export { useSubscriptionIdStore };
